<template>
  <div v-show="showBackButton" class="back-button d-md-block d-lg-none">
    <span @click="goBack()">
      <i class="fa fa-arrow-left"></i> Back
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showBackButton: true,
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  },
  created() {
    if(window.history.length <= 2) {
      this.showBackButton = false;
    }
  }
}
</script>

<style>
.back-btn-wrapper {
  margin-left: auto;
  margin-right: auto;
  width: 35%;
}
.back-button {
 font-size: 13px;
 margin-right: 0px;
 font-weight: 400;
 text-align: right;
}
.back-button span {
  background-color: #4c94cf;
  color: #FFF;
  padding: 3px 10px 3px 10px;
  border: 1px solid #4c94cf;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/goback.vue